import { afterNextRender, ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { bindAttribute } from '@bynary/composables/attribute';
import { useStorage } from '@bynary/composables/storage';
import { useI18n, useLanguage } from '@sona/angular-util-common';
import { Featurebase } from '@sona/angular-featurebase';
import { isAfter } from 'date-fns/isAfter';
import { toast } from 'ngx-sonner';

@Component({
    selector: 'sona-root',
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false,
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'c-sona-root'
    }
})
export class AppComponent {

    private readonly _i18n = useI18n();
    private readonly _hasDismissedRebrandingToast = useStorage<'true'>('hide-rebranding-toast');

    constructor() {
        inject(Featurebase);

        bindAttribute('lang',useLanguage(), { target: document.documentElement});

        afterNextRender(() => {
            if (isAfter(new Date(), new Date('2025-05-12')) || this._hasDismissedRebrandingToast() === 'true') {
                return;
            }

            setTimeout(() => {
                toast(this._i18n().t('REBRANDING_TOAST.TITLE'), {
                    description: this._i18n().t('REBRANDING_TOAST.DESCRIPTION'),
                    duration: Number.POSITIVE_INFINITY,
                    closeButton: true,
                    onDismiss: () => this._hasDismissedRebrandingToast.set('true'),
                    important: true,
                    position: 'top-center'
                });
            }, 1000);
        });
    }
}
